const initializeFestivalCheckIn = () => {
    const components =
        document.querySelectorAll(
            '[data-festival-check-in]'
        );

    components.forEach((component) => {
        const checkInForm =
            component.querySelector(
                '[data-festival-check-in-form]'
            );

        const checkInUpdateForm =
            component.querySelector(
                '[data-festival-check-in-update-form]'
            );

        const checkOutForm =
            component.querySelector(
                '[data-festival-check-out-form]'
            );

        const checkedInState =
            component.querySelector(
                '[data-festival-checked-in-state]'
            );

        const checkedOutState =
            component.querySelector(
                '[data-festival-checked-out-state]'
            );

        const message =
            component.querySelector(
                '[data-festival-check-in-message]'
            );

        const visibilityLabel =
            component.querySelector(
                '[data-festival-check-in-visibility-label]'
            );

        const checkedInTime =
            component.querySelector(
                '[data-festival-check-in-time]'
            );

        const currentlyHereSection =
            document.querySelector(
                '[data-festival-currently-here]'
            );

        const currentlyHereList =
            currentlyHereSection?.querySelector(
                '[data-festival-currently-here-list]'
            );

        const currentlyHereCount =
            currentlyHereSection?.querySelector(
                '[data-festival-currently-here-count]'
            );

        const currentlyHereGroups = {
            currentUser:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group="current-user"]'
                ) ?? null,

            friends:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group="friends"]'
                ) ?? null,

            others:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group="others"]'
                ) ?? null,
        };

        const currentlyHereGroupLists = {
            currentUser:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-list="current-user"]'
                ) ?? null,

            friends:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-list="friends"]'
                ) ?? null,

            others:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-list="others"]'
                ) ?? null,
        };

        const currentlyHereGroupCounts = {
            currentUser:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-count="current-user"]'
                ) ?? null,

            friends:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-count="friends"]'
                ) ?? null,

            others:
                currentlyHereSection?.querySelector(
                    '[data-currently-here-group-count="others"]'
                ) ?? null,
        };

        const currentlyHereEmptyState =
            currentlyHereSection?.querySelector(
                '[data-festival-currently-here-empty]'
            ) ?? null;

        const currentlyHereUrl =
            currentlyHereSection
                ?.dataset
                .currentlyHereUrl
            ?? null;

        const friendArrivalToast =
            document.querySelector(
                '[data-friend-arrival-toast]'
            );

        const friendArrivalTitle =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-title]'
            );

        const friendArrivalMessage =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-message]'
            );

        const friendArrivalLiveLocation =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-live-location]'
            );

        const friendArrivalPhoto =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-photo]'
            );

        const friendArrivalViewLink =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-view]'
            );

        const friendArrivalDismissButton =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-dismiss]'
            );

        const friendArrivalCloseButton =
            friendArrivalToast?.querySelector(
                '[data-friend-arrival-close]'
            );

        let checkInRequestInProgress =
            false;

        let currentlyHerePollInProgress =
            false;

        let currentlyHerePollTimerId =
            null;

        let lastCurrentlyHereSignature =
            null;

        let knownCurrentlyHereMemberIds =
            null;

        let friendArrivalToastTimerId =
            null;

        const clearMessage = () => {
            if (!message) {
                return;
            }

            message.textContent = '';

            message.classList.add(
                'hidden'
            );

            message.classList.remove(
                'border-emerald-300',
                'bg-emerald-50',
                'text-emerald-800',
                'dark:border-emerald-400/30',
                'dark:bg-emerald-400/10',
                'dark:text-emerald-200',
                'border-rose-300',
                'bg-rose-50',
                'text-rose-700',
                'dark:border-rose-400/30',
                'dark:bg-rose-400/10',
                'dark:text-rose-200'
            );
        };

        const showMessage = (
            text,
            type = 'success'
        ) => {
            if (!message) {
                return;
            }

            clearMessage();

            message.textContent = text;

            message.classList.remove(
                'hidden'
            );

            if (type === 'error') {
                message.classList.add(
                    'border-rose-400/30',
                    'bg-rose-400/10',
                    'text-rose-200'
                );

                return;
            }

            message.classList.add(
                'border-emerald-300',
                'bg-emerald-50',
                'text-emerald-800',
                'dark:border-emerald-400/30',
                'dark:bg-emerald-400/10',
                'dark:text-emerald-200'
            );
        };

        const getCurrentUserId = () => {
            return currentlyHereSection
                    ?.dataset
                    .currentUserId
                ?? '';
        };

        const getCurrentlyHereGroupKey = (
            member
        ) => {
            if (member.is_current_user) {
                return 'currentUser';
            }

            if (member.is_friend) {
                return 'friends';
            }

            return 'others';
        };

        const updateCurrentlyHereGroups = () => {
            const groupKeys = [
                'currentUser',
                'friends',
                'others',
            ];

            let totalCount = 0;

            groupKeys.forEach((groupKey) => {
                const group =
                    currentlyHereGroups[groupKey];

                const groupList =
                    currentlyHereGroupLists[groupKey];

                const groupCount =
                    currentlyHereGroupCounts[groupKey];

                const count =
                    groupList
                        ?.querySelectorAll(
                            '[data-currently-here-member]'
                        )
                        .length
                    ?? 0;

                totalCount += count;

                if (groupCount) {
                    groupCount.textContent =
                        String(count);
                }

                group?.classList.toggle(
                    'hidden',
                    count === 0
                );
            });

            if (currentlyHereCount) {
                currentlyHereCount.textContent =
                    String(totalCount);
            }

            currentlyHereEmptyState
                ?.classList.toggle(
                'hidden',
                totalCount > 0
            );
        };

        const updateHighlights = () => {
            const checkedInElement =
                document.querySelector(
                    '[data-highlight-checked-in]'
                );

            if (checkedInElement) {
                checkedInElement.textContent =
                    currentlyHereCount?.textContent ?? '0';
            }

            const topLocationElement =
                document.querySelector(
                    '[data-highlight-top-location]'
                );

            if (!topLocationElement) {
                return;
            }

            const counts = {};

            currentlyHereList
                ?.querySelectorAll(
                    '[data-currently-here-member]'
                )
                .forEach((card) => {
                    const location =
                        card.querySelector(
                            '.text-emerald-200'
                        )?.textContent;

                    if (!location) {
                        return;
                    }

                    counts[location] =
                        (counts[location] ?? 0) + 1;
                });

            const winner =
                Object.entries(counts)
                    .sort(
                        (a, b) => b[1] - a[1]
                    )[0];

            topLocationElement.textContent =
                winner
                    ? winner[0]
                    : 'No live locations yet';
        };

        const updateCommandBar = (
            checkedIn
        ) => {
            document
                .querySelectorAll(
                    '[data-command-check-in-label]'
                )
                .forEach((element) => {
                    element.textContent =
                        checkedIn
                            ? 'Update Check-In'
                            : 'Check In';
                });

            document
                .querySelectorAll(
                    '[data-command-location-label]'
                )
                .forEach((element) => {
                    element.textContent =
                        checkedIn
                            ? 'Share Location'
                            : 'Live Map';
                });
        };

        const hideFriendArrivalToast = () => {
            if (!friendArrivalToast) {
                return;
            }

            if (friendArrivalToastTimerId !== null) {
                window.clearTimeout(
                    friendArrivalToastTimerId
                );

                friendArrivalToastTimerId = null;
            }

            friendArrivalToast.classList.add(
                'translate-y-[-12px]',
                'opacity-0'
            );

            window.setTimeout(
                () => {
                    friendArrivalToast.classList.add(
                        'hidden'
                    );
                },
                300
            );
        };

        const showFriendArrivalToast = (
            member
        ) => {
            if (
                !friendArrivalToast
                || !member
            ) {
                return;
            }

            if (friendArrivalToastTimerId !== null) {
                window.clearTimeout(
                    friendArrivalToastTimerId
                );
            }

            const memberName =
                member.name
                || 'Your friend';

            const locationLabels = {
                main_stage: 'Main Stage',
                secondary_stage: 'Secondary Stage',
                campground: 'Campground',
                food: 'Food Court',
                vendors: 'Vendor Village',
                parking: 'Parking',
                entrance: 'Entrance',
                other: 'another festival area',
            };

            const locationLabel =
                member.current_location
                    ? locationLabels[
                    member.current_location
                    ] ?? 'the festival'
                    : 'the festival';

            if (friendArrivalTitle) {
                friendArrivalTitle.textContent =
                    `${memberName} just checked in!`;
            }

            if (friendArrivalMessage) {
                friendArrivalMessage.textContent =
                    member.current_location
                        ? `${memberName} is now at ${locationLabel}.`
                        : `${memberName} is now at the festival.`;
            }

            if (friendArrivalLiveLocation) {
                if (member.has_live_location) {
                    friendArrivalLiveLocation.classList.add(
                        'hidden'
                    );

                    friendArrivalLiveLocation.textContent = '';
                } else {
                    friendArrivalLiveLocation.textContent =
                        'Live location is not currently being shared.';

                    friendArrivalLiveLocation.classList.remove(
                        'hidden'
                    );
                }
            }

            if (friendArrivalViewLink) {
                if (member.has_live_location) {
                    friendArrivalViewLink.href =
                        '#festival-live-map';

                    friendArrivalViewLink.dataset.memberId =
                        String(member.id);

                    friendArrivalViewLink.textContent =
                        '📍 Show on Live Map';
                } else {
                    friendArrivalViewLink.href =
                        member.profile_url ?? '#';

                    delete friendArrivalViewLink.dataset.memberId;

                    friendArrivalViewLink.textContent =
                        `👤 View ${memberName}`;
                }
            }

            if (friendArrivalPhoto) {
                friendArrivalPhoto.replaceChildren();

                if (member.profile_photo_url) {
                    const image =
                        document.createElement(
                            'img'
                        );

                    image.src =
                        member.profile_photo_url;

                    image.alt =
                        memberName;

                    image.className =
                        'h-full w-full object-cover';

                    friendArrivalPhoto.appendChild(
                        image
                    );
                } else {
                    friendArrivalPhoto.textContent =
                        member.initials
                        || memberName
                            .charAt(0)
                            .toUpperCase();
                }
            }

            friendArrivalToast.classList.remove(
                'hidden'
            );

            window.requestAnimationFrame(
                () => {
                    friendArrivalToast.classList.remove(
                        'translate-y-[-12px]',
                        'opacity-0'
                    );
                }
            );

            friendArrivalToastTimerId =
                window.setTimeout(
                    hideFriendArrivalToast,
                    8000
                );
        };

        const clearCurrentlyHereGroups = () => {
            Object
                .values(currentlyHereGroupLists)
                .forEach((groupList) => {
                    groupList
                        ?.querySelectorAll(
                            '[data-currently-here-member]'
                        )
                        .forEach((card) => {
                            card.remove();
                        });
                });
        };

        const addMemberToCurrentlyHereGroup = (
            member,
            checkedInAtHuman = 'just now',
            prepend = false
        ) => {
            const groupKey =
                getCurrentlyHereGroupKey(member);

            const groupList =
                currentlyHereGroupLists[groupKey];

            if (!groupList) {
                return;
            }

            const card =
                createCurrentlyHereMemberCard(
                    member,
                    checkedInAtHuman
                );

            if (prepend) {
                groupList.prepend(card);

                return;
            }

            groupList.appendChild(card);
        };

        const addCurrentMemberToCurrentlyHere = (
            data
        ) => {
            if (
                !currentlyHereList
                || !data.member
            ) {
                return;
            }

            const memberId =
                String(data.member.id);

            currentlyHereList
                .querySelector(
                    `[data-currently-here-member="${memberId}"]`
                )
                ?.remove();

            addMemberToCurrentlyHereGroup(
                data.member,
                data.checked_in_at_human
                ?? data.member.checked_in_at_human
                ?? 'just now',
                true
            );

            updateCurrentlyHereGroups();

            lastCurrentlyHereSignature =
                null;

            updateHighlights();
        };

        const removeCurrentMemberFromCurrentlyHere =
            () => {
                if (!currentlyHereList) {
                    return;
                }

                const currentUserId =
                    getCurrentUserId();

                if (!currentUserId) {
                    return;
                }

                currentlyHereList
                    .querySelector(
                        `[data-currently-here-member="${currentUserId}"]`
                    )
                    ?.remove();

                updateCurrentlyHereGroups();

                lastCurrentlyHereSignature =
                    null;

                updateHighlights();
            };

        const synchronizeCurrentlyHereMembers = (
            members
        ) => {
            if (!currentlyHereList) {
                return;
            }

            const normalizedMembers =
                Array.isArray(members)
                    ? members
                    : [];

            const nextMemberIds =
                new Set(
                    normalizedMembers.map(
                        (member) =>
                            String(member.id)
                    )
                );

            if (knownCurrentlyHereMemberIds !== null) {
                const newlyArrivedFriend =
                    normalizedMembers.find(
                        (member) =>
                            member.is_friend === true
                            && !member.is_current_user
                            && !knownCurrentlyHereMemberIds
                                .has(
                                    String(member.id)
                                )
                    );

                if (newlyArrivedFriend) {
                    showFriendArrivalToast(
                        newlyArrivedFriend
                    );
                }
            }

            knownCurrentlyHereMemberIds =
                nextMemberIds;

            const signature =
                JSON.stringify(
                    normalizedMembers.map(
                        (member) => [
                            String(member.id),

                            member.is_current_user
                                ? '1'
                                : '0',

                            member.is_friend
                                ? '1'
                                : '0',

                            member.name
                            ?? '',

                            member.profile_url
                            ?? '',

                            member.profile_photo_url
                            ?? '',

                            member.checked_in_at_human
                            ?? '',

                            member.current_location
                            ?? '',

                            member.current_status
                            ?? '',

                            member.current_status_note
                            ?? '',

                            member.status_updated_at_human
                            ?? '',
                        ]
                    )
                );

            /*
             * Avoid rebuilding the groups when the
             * visible member data has not changed.
             */
            if (
                signature
                === lastCurrentlyHereSignature
            ) {
                return;
            }

            lastCurrentlyHereSignature =
                signature;

            clearCurrentlyHereGroups();

            normalizedMembers.forEach(
                (member) => {
                    addMemberToCurrentlyHereGroup(
                        member,
                        member.checked_in_at_human
                        ?? 'just now'
                    );
                }
            );

            updateCurrentlyHereGroups();
            updateHighlights();
        };

        const createCurrentlyHereMemberCard = (
            member,
            checkedInAtHuman = 'just now'
        ) => {
            const article =
                document.createElement(
                    'article'
                );

            article.className =
                'flex items-center gap-4 rounded-2xl border border-emerald-400/20 bg-emerald-400/10 p-4';

            article.dataset
                .currentlyHereMember =
                String(member.id);

            const profileLink =
                document.createElement('a');

            profileLink.href =
                member.profile_url
                || '#';

            profileLink.className =
                'h-14 w-14 shrink-0 overflow-hidden rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500';

            if (member.profile_photo_url) {
                const image =
                    document.createElement(
                        'img'
                    );

                image.src =
                    member.profile_photo_url;

                image.alt =
                    member.name
                    || 'Member';

                image.className =
                    'h-full w-full object-cover';

                profileLink.appendChild(
                    image
                );
            } else {
                const initials =
                    document.createElement(
                        'span'
                    );

                initials.className =
                    'flex h-full w-full items-center justify-center text-xl font-black text-white';

                initials.textContent =
                    member.initials
                    || '?';

                profileLink.appendChild(
                    initials
                );
            }

            const memberDetails =
                document.createElement('div');

            memberDetails.className =
                'min-w-0';

            const memberNameRow =
                document.createElement('div');

            memberNameRow.className =
                'flex min-w-0 items-center gap-2';

            const memberName =
                document.createElement('a');

            memberName.href =
                member.profile_url
                || '#';

            memberName.className =
                'min-w-0 truncate font-black text-zinc-950 transition hover:text-emerald-700 dark:text-white dark:hover:text-emerald-200';

            memberName.textContent =
                member.name
                || 'FestFriends member';

            memberNameRow.appendChild(
                memberName
            );

            if (
                member.is_friend
                || member.is_current_user
            ) {
                const memberBadge =
                    document.createElement('span');

                memberBadge.className =
                    member.is_friend
                        ? 'shrink-0 rounded-full border border-fuchsia-400/30 bg-fuchsia-400/10 px-2 py-0.5 text-xs font-bold text-fuchsia-200'
                        : 'shrink-0 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-2 py-0.5 text-xs font-bold text-emerald-200';

                memberBadge.textContent =
                    member.is_friend
                        ? 'Friend'
                        : 'You';

                memberNameRow.appendChild(
                    memberBadge
                );
            }

            const location =
                document.createElement('p');

            location.className =
                'mt-1 text-sm font-semibold text-emerald-200';

            const locationLabels = {
                main_stage: '🎵 Main Stage',
                secondary_stage: '🎶 Secondary Stage',
                campground: '⛺ Campground',
                food: '🍔 Food Court',
                vendors: '🛍️ Vendor Village',
                parking: '🚗 Parking',
                entrance: '🚪 Entrance',
                other: '📍 Other',
            };

            location.textContent =
                locationLabels[
                    member.current_location
                    ] ?? '📍 Here now';

            const statusLabels = {
                meeting_people:
                    '👋 Looking to meet people',
                with_group:
                    '🧑‍🤝‍🧑 With my group',
                waiting:
                    '⏳ Waiting for friends',
                dancing:
                    '💃 Dancing',
                exploring:
                    '🚶 Exploring',
                taking_break:
                    '😌 Taking a break',
                leaving:
                    '🚗 Leaving soon',
            };

            const currentStatus =
                document.createElement('p');

            currentStatus.className =
                'mt-1 text-sm font-semibold text-cyan-700 dark:text-cyan-200';

            currentStatus.textContent =
                statusLabels[
                    member.current_status
                    ] ?? '';

            const currentStatusNote =
                document.createElement('p');

            currentStatusNote.className =
                'mt-1 text-sm text-zinc-700 dark:text-slate-300';

            currentStatusNote.textContent =
                member.current_status_note
                ?? '';

            const statusUpdatedTime =
                document.createElement('p');

            statusUpdatedTime.className =
                'mt-1 text-xs text-cyan-300/70';

            statusUpdatedTime.textContent =
                `Updated ${
                    member.status_updated_at_human
                    || 'just now'
                }`;

            const checkedInTime =
                document.createElement('p');

            checkedInTime.className =
                'mt-1 text-xs text-slate-500';

            checkedInTime.textContent =
                `Checked in ${
                    checkedInAtHuman
                    || 'just now'
                }`;

            memberDetails.appendChild(
                memberNameRow
            );

            memberDetails.appendChild(
                location
            );

            if (currentStatus.textContent) {
                memberDetails.appendChild(
                    currentStatus
                );
            }

            if (currentStatusNote.textContent) {
                memberDetails.appendChild(
                    currentStatusNote
                );
            }

            if (
                currentStatus.textContent
                || currentStatusNote.textContent
            ) {
                memberDetails.appendChild(
                    statusUpdatedTime
                );
            }

            memberDetails.appendChild(
                checkedInTime
            );

            article.appendChild(
                profileLink
            );

            article.appendChild(
                memberDetails
            );

            return article;
        };


        const pollCurrentlyHereMembers =
            async () => {
                if (
                    !currentlyHereUrl
                    || !currentlyHereList
                    || document.hidden
                    || checkInRequestInProgress
                    || currentlyHerePollInProgress
                ) {
                    return;
                }

                currentlyHerePollInProgress =
                    true;

                try {
                    const response =
                        await fetch(
                            currentlyHereUrl,
                            {
                                method: 'GET',

                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',
                                },

                                cache:
                                    'no-store',
                            }
                        );

                    if (
                        response.status === 401
                        || response.status === 419
                    ) {
                        if (
                            currentlyHerePollTimerId
                            !== null
                        ) {
                            window.clearInterval(
                                currentlyHerePollTimerId
                            );

                            currentlyHerePollTimerId =
                                null;
                        }

                        return;
                    }

                    if (!response.ok) {
                        return;
                    }

                    const data =
                        await response.json();

                    synchronizeCurrentlyHereMembers(
                        data.members
                    );
                } catch (error) {
                    /*
                     * Polling failures remain silent.
                     * The next scheduled request can retry.
                     */
                } finally {
                    currentlyHerePollInProgress =
                        false;
                }
            };
        const setCheckedIn = (
            data
        ) => {
            checkedInState?.classList.remove(
                'hidden'
            );

            checkedOutState?.classList.add(
                'hidden'
            );

            if (visibilityLabel) {
                visibilityLabel.textContent =
                    data.visibility_label
                    || 'your confirmed friends';
            }

            if (checkedInTime) {
                checkedInTime.textContent =
                    `Checked in ${
                        data.checked_in_at_human
                        || 'just now'
                    }`;
            }

            addCurrentMemberToCurrentlyHere(
                data
            );

            updateCommandBar(true);

            window.dispatchEvent(
                new CustomEvent(
                    'festival:check-in-changed',
                    {
                        detail: {
                            checkedIn: true,
                        },
                    }
                )
            );
        };

        const setCheckedOut = () => {
            checkedInState?.classList.add(
                'hidden'
            );

            checkedOutState?.classList.remove(
                'hidden'
            );

            removeCurrentMemberFromCurrentlyHere();

            updateCommandBar(false);

            window.dispatchEvent(
                new CustomEvent(
                    'festival:check-in-changed',
                    {
                        detail: {
                            checkedIn: false,
                        },
                    }
                )
            );
        };

        const submitForm = async (
            form,
            loadingText
        ) => {
            const submitButton =
                form.querySelector(
                    '[data-festival-check-in-submit]'
                );

            if (
                !(submitButton instanceof
                    HTMLButtonElement)
            ) {
                return;
            }

            clearMessage();

            checkInRequestInProgress = true;

            const originalText =
                submitButton.textContent;

            submitButton.disabled = true;

            submitButton.textContent =
                loadingText;

            try {
                const response = await fetch(
                    form.action,
                    {
                        method:
                            form.method
                                .toUpperCase(),

                        credentials:
                            'same-origin',

                        headers: {
                            Accept:
                                'application/json',

                            'X-Requested-With':
                                'XMLHttpRequest',
                        },

                        body:
                            new FormData(form),
                    }
                );

                const data =
                    await response.json();

                if (!response.ok) {
                    const validationMessage =
                        data.errors
                            ? Object
                                .values(
                                    data.errors
                                )
                                .flat()
                                .find(Boolean)
                            : null;

                    throw new Error(
                        validationMessage
                        || data.message
                        || 'The request could not be completed.'
                    );
                }

                if (data.checked_in) {
                    setCheckedIn(data);
                } else {
                    setCheckedOut();
                }

                showMessage(
                    data.message
                    || 'Your check-in was updated.'
                );
            } catch (error) {
                showMessage(
                    error.message
                    || 'The request could not be completed.',
                    'error'
                );
            } finally {

                checkInRequestInProgress = false;

                lastCurrentlyHereSignature = null;

                submitButton.disabled = false;

                submitButton.textContent = originalText;
            }
        };

        friendArrivalDismissButton
            ?.addEventListener(
                'click',
                hideFriendArrivalToast
            );

        friendArrivalCloseButton
            ?.addEventListener(
                'click',
                hideFriendArrivalToast
            );

        friendArrivalViewLink
            ?.addEventListener(
                'click',
                (event) => {
                    event.preventDefault();

                    window.dispatchEvent(
                        new CustomEvent(
                            'festival:focus-member',
                            {
                                detail: {
                                    memberId:
                                    friendArrivalViewLink.dataset.memberId,
                                },
                            }
                        )
                    );

                    hideFriendArrivalToast();
                }
            );

        updateCommandBar(
            ! checkedInState?.classList.contains(
                'hidden'
            )
        );

        checkInForm?.addEventListener(
            'submit',
            (event) => {
                event.preventDefault();

                submitForm(
                    checkInForm,
                    'Checking In...'
                );
            }
        );

        checkInUpdateForm?.addEventListener(
            'submit',
            (event) => {
                event.preventDefault();

                submitForm(
                    checkInUpdateForm,
                    'Saving Update...'
                );
            }
        );

        checkOutForm?.addEventListener(
            'submit',
            (event) => {
                event.preventDefault();

                submitForm(
                    checkOutForm,
                    'Checking Out...'
                );
            }
        );

        if (
            currentlyHereUrl
            && currentlyHereList
        ) {
            currentlyHerePollTimerId =
                window.setInterval(
                    pollCurrentlyHereMembers,
                    30000
                );

            document.addEventListener(
                'visibilitychange',
                () => {
                    if (!document.hidden) {
                        pollCurrentlyHereMembers();
                    }
                }
            );

            window.addEventListener(
                'pagehide',
                () => {
                    if (
                        currentlyHerePollTimerId
                        === null
                    ) {
                        return;
                    }

                    window.clearInterval(
                        currentlyHerePollTimerId
                    );

                    currentlyHerePollTimerId =
                        null;
                },
                {
                    once: true,
                }
            );
        }
    });
};

if (
    document.readyState === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeFestivalCheckIn
    );
} else {
    initializeFestivalCheckIn();
}